import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/quotation/Quotation.jsx");
